// import React, { useState } from "react";
// import { Button, TextField, Typography } from "@mui/material";
// import { NER_BACKEND_URL } from "../Config";
// import TaggyJr from "react-taggy-jr";

// const submitNER = async (text) => {
//     const response = await fetch(NER_BACKEND_URL+`/ner?text=${text}`)
//     if (!response.ok){
//         return [null, false]
//     } else {
//         const data = await response.json()
//         return [data,true]
//     }
// };

// const colors = [
//     [255, 75, 75], [255, 35, 164], [255, 53, 227],
//     [33, 195, 84], [0, 212, 177], [0, 192, 242], [150, 150, 150]
// ].map(arr => ({ r: arr[0], g: arr[1], b: arr[2] }));

// const colorsType = {
//     'substance': colors[0],
//     'strength': colors[1],
//     'drug': colors[2],
//     'form': colors[3],
//     'component': colors[4],
//     'distinction': colors[5],
//     'roa': colors[6]
// };

// /**
//  * Transforms API offsets into a format TaggyJr can render.
//  * It fills the "gaps" between annotations with plain text strings.
//  */
// const transformAnnotations = (fullText, annotations) => {
//     if (!annotations || !fullText) return [];
    
//     const result = [];
//     let lastIndex = 0;

//     const sorted = [...annotations].sort((a, b) => a.start - b.start);

//     sorted.forEach((ann) => {
//         if (ann.start > lastIndex) {
//             result.push(fullText.substring(lastIndex, ann.start));
//         }
//         result.push([ann.text, ann.label]);
//         lastIndex = ann.end;
//     });

//     if (lastIndex < fullText.length) {
//         result.push(fullText.substring(lastIndex));
//     }

//     return result;
// };

// const NERVisualizer = ({ annotation }) => {
//     return annotation?.map((el, index) => {
//         if (typeof el === 'string') {
//             return <span key={index}>{el}</span>;
//         }
//         const [text, type] = el;
//         return <TaggyJr key={index} text={text} type={type} color={colorsType[type] || {r:200, g:200, b:200}} />;
//     });
// };

// export function NERPlayground() {
//     const [data, setData] = useState(null);
//     const [inputText, setInputText] = useState("");
//     const [hasData, setHasData] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const form = new FormData(e.target);
//         const text = form.get('text');
//         setInputText(text); // Store text to use for transformation

//         const [resData, isOk] = await submitNER(text);
//         setData(resData);
//         setHasData(isOk);
//     };

//     return (
//         <div style={{ width: "80%", margin: "auto", paddingTop: "2rem" }}>
//             <form onSubmit={handleSubmit}>
//                 <Typography paddingBottom={3}>Enter your text below</Typography>
//                 <TextField
//                     multiline
//                     name="text"
//                     label="Input Text"
//                     variant="outlined"
//                     fullWidth
//                     margin="dense"
//                 />
//                 <div style={{ marginTop: "1rem" }}>
//                     <Button type="submit" variant="contained">Submit</Button>
//                 </div>
//             </form>

//             {hasData && data && (
//                 <div>
//                     <Typography paddingTop={4} paddingBottom={2}>Results</Typography>
//                     <div style={{ lineHeight: "2.5rem" }}>
//                         <NERVisualizer 
//                             annotation={transformAnnotations(inputText, data.annotation)} 
//                         />
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default NERPlayground;
import React, { useState } from "react";
import { Button, TextField, Typography } from "@mui/material";
import { NER_BACKEND_URL } from "../Config";
import TaggyJr from "react-taggy-jr";

const submitNER = async (text) => {
    const response = await fetch(NER_BACKEND_URL + `/ner?text=${text}`);
    if (!response.ok) {
        return [null, false];
    } else {
        const data = await response.json();
        return [data, true];
    }
};

const colors = [
    [255, 75, 75], [255, 35, 164], [255, 53, 227],
    [33, 195, 84], [0, 212, 177], [0, 192, 242], [150, 150, 150]
].map(arr => ({ r: arr[0], g: arr[1], b: arr[2] }));

const colorsType = {
    'substance': colors[0],
    'strength': colors[1],
    'drug': colors[2],
    'form': colors[3],
    'component': colors[4],
    'distinction': colors[5],
    'roa': colors[6]
};

/**
 * Transforms API offsets into multiple layers to cleanly handle overlapping tags.
 * Each layer represents a complete repetition of the text containing a non-overlapping subset of tags.
 */
const transformAnnotations = (fullText, annotations) => {
    if (!fullText) return [];
    if (!annotations || annotations.length === 0) return [[fullText]];
    
    // 1. Sort annotations by starting index
    const sorted = [...annotations].sort((a, b) => a.start - b.start);

    // 2. Greedy interval partitioning into multiple layers
    const layers = [];     // Array of arrays holding annotations assigned to each layer
    const layerEnds = [];  // Tracks the ending index of the last annotation in each layer

    sorted.forEach((ann) => {
        let placed = false;
        for (let i = 0; i < layers.length; i++) {
            // If the current annotation starts after (or when) the last one in this layer ends
            if (ann.start >= layerEnds[i]) {
                layers[i].push(ann);
                layerEnds[i] = ann.end;
                placed = true;
                break;
            }
        }
        // If it overlaps with every existing layer, create a new one
        if (!placed) {
            layers.push([ann]);
            layerEnds.push(ann.end);
        }
    });

    // 3. Generate the isolated text and tag arrays for each isolated layer
    return layers.map((layerAnns) => {
        const result = [];
        let lastIndex = 0;

        layerAnns.forEach((ann) => {
            if (ann.start > lastIndex) {
                result.push(fullText.substring(lastIndex, ann.start));
            }
            result.push([ann.text, ann.label]);
            lastIndex = ann.end;
        });

        if (lastIndex < fullText.length) {
            result.push(fullText.substring(lastIndex));
        }

        return result;
    });
};

const NERVisualizer = ({ annotationLayers }) => {
    if (!annotationLayers) return null;

    return annotationLayers.map((layer, layerIndex) => (
        // Each layer gets wrapped in a block element (div) to force a new line
        <div key={layerIndex} style={{ marginBottom: "1.5rem", borderBottom: "1px dashed #eee", paddingBottom: "0.5rem" }}>
            {layer.map((el, index) => {
                if (typeof el === 'string') {
                    return <span key={index}>{el}</span>;
                }
                const [text, type] = el;
                return <TaggyJr key={index} text={text} type={type} color={colorsType[type] || { r: 200, g: 200, b: 200 }} />;
            })}
        </div>
    ));
};

export function NERPlayground() {
    const [data, setData] = useState(null);
    const [inputText, setInputText] = useState("");
    const [hasData, setHasData] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData(e.target);
        const text = form.get('text');
        setInputText(text);

        const [resData, isOk] = await submitNER(text);
        setData(resData);
        setHasData(isOk);
    };

    return (
        <div style={{ width: "80%", margin: "auto", paddingTop: "2rem" }}>
            <form onSubmit={handleSubmit}>
                <Typography paddingBottom={3}>Enter your text below</Typography>
                <TextField
                    multiline
                    name="text"
                    label="Input Text"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                />
                <div style={{ marginTop: "1rem" }}>
                    <Button type="submit" variant="contained">Submit</Button>
                </div>
            </form>

            {hasData && data && (
                <div>
                    <Typography paddingTop={4} paddingBottom={2}>Results</Typography>
                    <div style={{ lineHeight: "2.5rem" }}>
                        <NERVisualizer 
                            annotationLayers={transformAnnotations(inputText, data.annotation)} 
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default NERPlayground;